import React, { Component } from 'react'
import { connect } from "react-redux";
import { Helmet } from 'react-helmet-async';
import { Button } from 'reactstrap';
import MUIDataTable from "mui-datatables";
import IconButton from '@mui/material/IconButton';
// intl messages
import IntlMessages from 'Util/IntlMessages';
// page title bar
import PageTitleBar from 'Components/PageTitleBar/PageTitleBar';
// app config
import AppConfig from 'Constants/AppConfig';
import ConfirmationDialog from "Routes/common/ConfirmationDialog";
import Selectsearch from "react-select";
import {
	FormGroup,
	Label,	
} from 'reactstrap';

import {
   allOCTBunkerPlay,
   deletePuttPerformance,
   studentPuttPerformance,
   fetchPuttPerformance,
   allStudents,
} from 'Actions';

// rct card box
import RctCollapsibleCard from 'Components/RctCollapsibleCard/RctCollapsibleCard';

import AddItem from './component/addform';
import EditItem from './component/editform';

import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';

class puttperformance extends Component {
   
   constructor(props) {
      
      super(props);
      this.confirmationDialog = React.createRef();
         this.state = {
            viewdiv:true,
            listdiv:false,
            adddiv:false,
            editdiv:false,
            seldate:'', 
            student:'',
            sepmore:1,
            totavgpoints:0,
            formValues: [{ puttlength:"", noputt:"", putttype:"", right : "", left : "", short : "", long : "", avgputt:"", strokes:"", disright:"", disleft:"", disshort:"", dislong:""}],
         };  
         
         this.onBackSection = this.onBackSection.bind(this);
         this.deleteForm = this.deleteForm.bind(this);
   } 

   UNSAFE_componentWillMount() {
      this.props.allStudents();
	}

   onAddSession() {
		this.setState({
         viewdiv:false,
         listdiv:false,
         editdiv:false,
         adddiv:true,
      });
   } 
      
   onBackSection() {
		this.setState({ 
         adddiv:false,
         editdiv:false,
         viewdiv:true,
         listdiv:true,
       });
	}
   
   selstudent = (evt) =>{
      var stdid=evt.value;
      this.setState({ student:stdid });
      var start='';
      var end='';
      this.props.studentPuttPerformance(stdid, start, end).then((data) => {   
         
         this.setState({ 
             listdiv:true,               
             adddiv:false,
             editdiv:false,
         });

     });
   }


   editAssessment(assmval){
        
      var id=assmval.gpp_userID;
      var date=assmval.gpp_date;
        
        this.props.fetchPuttPerformance(id, date).then((data) => {   
            var resdata=data.data;
            var troptobj=[]; 
            var st=0;
            {resdata.map((teamval) => (   

               troptobj.push({
                  puttlength:teamval.gpp_puttlength,
                  noputt:teamval.gpp_noputt,
                  putttype:teamval.gpp_putttype,
                  right: teamval.gpp_right,
                  left: teamval.gpp_left,
                  short: teamval.gpp_short,
                  long: teamval.gpp_long,
                  avgputt:teamval.gpp_avgputt,
                  strokes: teamval.gpp_strokes,
                  disright:teamval.gpp_right==0 ? 0 : 1, 
                  disleft:teamval.gpp_left==0 ? 0 : 1, 
                  disshort:teamval.gpp_short==0 ? 0 : 1, 
                  dislong:teamval.gpp_long==0 ? 0 : 1,                  

               }),
               st=parseFloat(st)+parseFloat(teamval.gpp_strokes)
            ))} 
            
            var totavg=parseFloat((st).toFixed(4));
            
            this.setState({ 
               seldate:resdata[0].gpp_date, 
               student:resdata[0].gpp_userID,
               formValues:troptobj,
               sepmore:resdata.length,
               totavgpoints:totavg
            });

            this.setState({ 
                viewdiv:false,  
                listdiv:false,              
                adddiv:false,
                editdiv:true,
            });

        });
    }

    deleteForm(assmval){
      this.id = assmval.gpp_userID;
      this.date = assmval.gpp_date;
      this.confirmationDialog.current.openDialog();
    }

   deleteDataPermanent(popupResponse){
      
         if (popupResponse) {
            this.props.deletePuttPerformance(this.id, this.date);
            this.data = ""
         }
   }

   

    render() {
      const { match, studentlists, puttperformancelist, loading } = this.props;
      const allstudent=studentlists.map((stdval) => {  
         return {
            label: stdval.student,  
            value: stdval.uudID
         }
      });
      const options = {
            filterType: 'dropdown',
            rowsPerPage: 50,
            responsive:'standard',
            rowsPerPageOptions: [50, 100, 150],
            selectableRowsHideCheckboxes: true,
      };

      const columns = [
            { name: "no", label: "NO" },
            { name: "name", label: "NAME" },
            { name: "cdate", label: "DATE" },
            { name: "action", label: "EDIT" },
            { name: "action1", label: "DELETE" },
          
      ];
        const tabledata=puttperformancelist.map((assmntval,idx) => {     
               const ebtn=<IconButton className='text-info' onClick={ ()=>this.editAssessment(assmntval)}><EditOutlinedIcon/></IconButton>;     
               const dbtn=<IconButton  className="text-danger" aria-label="Remove" onClick={ ()=>this.deleteForm(assmntval)}  ><DeleteOutlineOutlinedIcon/></IconButton>;
                
                return {
                  no:idx+1,
                  name: assmntval.student,
                  cdate: assmntval.cdate,
                  action: ebtn,
                  action1:dbtn,
                
                }
        }); 

       return (
          <div className="saas-dashboard">
             <Helmet>
                <title>Putt Performance | {AppConfig.appTitle}</title>
                <meta name="description" content="Golf" />
             </Helmet>
             <PageTitleBar title={<IntlMessages id="sidebar.puttperformance" />} match={match} />
               {this.state.viewdiv && 
                  <div className="col-sm-12 col-lg-4" style={{margin:"0 auto"}}> 
                        <Label for="Select">Student *</Label> 
                        <FormGroup>   
                           <Label for="Select">Student *</Label>                                           
                           <Selectsearch id="student" name="student" placeholder="Select..." options={allstudent} rules={{ required: 'Please select an student'}} value={allstudent.find(obj => obj.value === this.state.student)} onChange={this.selstudent} required/>
                        </FormGroup>
                  </div>
               }                          
               {this.state.listdiv && 
                  <div className="col-sm-12 col-lg-8" style={{margin:"0 auto"}}>
                     <RctCollapsibleCard heading="List" fullBlock>
                        <MUIDataTable
                              title={<div><Button onClick={ ()=>this.onAddSession()} className="btn btn-outline-info"><i className="zmdi zmdi-plus-circle-o"></i>  Add Test</Button></div>}
                              data={tabledata}
                              columns={columns}
                              options={options} 
                        />   
                     </RctCollapsibleCard>
                  </div>
               }
               {this.state.adddiv && 
                  <AddItem onClick={this.onBackSection} data={this.state}/>                
               }

               {this.state.editdiv && 
                  <EditItem onClick={this.onBackSection} data={this.state}/>              
               }

            <ConfirmationDialog
               ref={this.confirmationDialog}
               onConfirm={(res) => this.deleteDataPermanent(res)}
               data={'putt performance'}
            />
                  
          </div>
       )
    }
 }

const mapStateToProps = ({ mostlyused, puttperformance }) => {
   const { studentlists } = mostlyused;
	const { puttperformancelist, loading } = puttperformance;
	return { studentlists, puttperformancelist, loading };
}

export default connect(mapStateToProps, {
  
   deletePuttPerformance,
   studentPuttPerformance,
   fetchPuttPerformance,
   allStudents
})(puttperformance); 